<div class="redirect-container">
  <div class="redirect-content">
    <h2>Account Not Found</h2>
    <p>You are not registered to use this application, maybe you are registered to use the MRO Portal. Try clicking the button below to redirect to the MRO Portal</p>
    <button class="redirect-button" (click)="redirectToMROPortal()">
      Go to MRO Portal
    </button>
  </div>
</div>
